import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

export const getCallHistorys = async (params = {}) => {
  try {
    const response = await api.get(`${API_URL}/callHistory`, {
      params: {
        page: params.page || 1,
        astroSearch: params.astroSearch || "", // Add astrologer search
        userSearch: params.userSearch || "", // Add user search
        startDate: params.startDate || "",
        endDate: params.endDate || "",
        sortOrder: params.sortOrder || "desc",
        limit: params.limit || 10,
        callStatus: params.callStatus || "",
        callType: params.callType || "",
      },
    });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};
